import { resourceReducer, getResources } from 'redux-resource';

export default resourceReducer('quickServiceCodes');

export const getAllQuickServiceCodes = (state) => getResources(state);
export const getQuickVendorServiceCodes = (state, vendor) =>
  getResources(state, `fetchQuickVendorServiceCodes_${vendor}`);
